import _objectWithoutProperties from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["url"];
import { createElementObject, createTileLayerComponent, updateGridLayer, withPane } from '@react-leaflet/core';
import { TileLayer as LeafletTileLayer } from 'leaflet';
export var TileLayer = createTileLayerComponent(function createTileLayer(_ref, context) {
  var url = _ref.url,
    options = _objectWithoutProperties(_ref, _excluded);
  var layer = new LeafletTileLayer(url, withPane(options, context));
  return createElementObject(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
  updateGridLayer(layer, props, prevProps);
  var url = props.url;
  if (url != null && url !== prevProps.url) {
    layer.setUrl(url);
  }
});